@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row && $.adata.fetch_key) {
    <span>{{ getMode($.row[$.adata.fetch_key]) }}</span>
  }
}
